
import React from 'react'
import { withResizeDetector } from 'react-resize-detector';

export default (Component) => {
  class ContainerWithResizeDetector extends React.Component {
    render() {
      return (
        <div className="container-with-resize-detector" style={{width:'100%', height: '100%'}}>
          <Component { ...this.props }/>
        </div>
      )
    }
  }

  return withResizeDetector(ContainerWithResizeDetector)
}